import { IndexedMap } from './map.utils';

export class ObjectUtils {
  static keys<T extends object>(obj: T): Array<keyof T> {
    return Object.keys(obj) as Array<keyof T>;
  }

  static toFilteredQueryParams<T extends object>(obj: T): string {
    return ObjectUtils.keys(obj)
      .filter((key) => obj[key])
      .map((key) => `${key as string}=${obj[key]}`)
      .join('&');
  }

  static toQueryParams<T extends object>(obj: T): string {
    return ObjectUtils.keys(obj)
      .map((key) => `${key as string}=${obj[key]}`)
      .join('&');
  }

  static hasProp<T extends object>(obj: T, prop: PropertyKey): boolean {
    return Object.hasOwn(obj, prop);
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  static getProp(obj: any, path?: string, translate?: IndexedMap<any, string>): any {
    if (!path) return obj;

    const props = path.split('.');

    for (let i = 0, iLen = props.length - 1; i < iLen; i++) {
      const prop = props[i];
      const candidate = obj[prop];

      if (candidate !== undefined) {
        obj = candidate;
      } else {
        break;
      }
    }

    const prop = obj ? obj[props[props.length - 1]] : null;
    if (translate && translate[prop]) {
      return translate[prop];
    }
    return prop;
  }

  static cloneDeep<T extends object>(obj: T): T {
    return ObjectUtils.deserialize(ObjectUtils.serialize(obj));
  }

  static serialize<T extends object>(obj: T): string {
    return JSON.stringify(obj);
  }

  static deserialize<T extends object>(strObj: string): T {
    return JSON.parse(strObj);
  }

  static isJsonString(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
